import { render, staticRenderFns } from "./CanvaPage.vue?vue&type=template&id=a7910c86&"
import script from "./CanvaPage.vue?vue&type=script&lang=js&"
export * from "./CanvaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports